import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

// Molde de PlatformRoute: el gate visual del portal del partner. La decisión de
// verdad la toma el backend (get_current_partner, que falla cerrada); esto solo
// evita mostrar una pantalla que la API va a rechazar. `es_partner` viene de
// /auth/me y usa LA MISMA resolución que la dependencia del backend.
export default function PartnerRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Loader2 className="w-8 h-8 animate-spin text-primary" />
            </div>
        );
    }

    if (!user || !user.es_partner) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
